import { Category, PartsProduct } from '@app/react/const/type';

type RT = Array<{ categoryId: number; categoryName: string, length: number }>;

export const buildCategoryLength = (
    categoryData: Array<Category>,
    partsData: Array<PartsProduct>,
): RT => (categoryData.map(({ categoryId, categoryName }) => {
    const { length } = partsData
        .filter((cat) => cat.categoryId === categoryId);

    return {
        categoryId,
        categoryName,
        length,
    };
}));
